class InvoiceService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    adminPortal = {
        receivable: {
            fetch: async (receivableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/receivable/${receivableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/receivable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/receivable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/receivable`, input);
                return data;
            },
            createAndCharge: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/receivable/create-and-charge`, input);
                return data;
            },
            update: async (receivableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/receivable/${receivableId}`, input);
                return data;
            },
            customerAccessToken: {
                create: async (create) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/invoice/receivable/customer-access-token`, create);
                    return data;
                },
            },
            pdf: {
                fetch: async (receivableID, params) => {
                    const res = await this.axiosInstance.mainInstance.get(`/pdf/admin-portal/invoice/${receivableID}`, {
                        responseType: 'blob',
                        params,
                    });
                    return res.data;
                },
            },
            combine: async (body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/combine-invoices`, body);
                return data;
            },
        },
        payable: {
            fetch: async (payableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payable/${payableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/payable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payable`, input);
                return data;
            },
            update: async (payableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/payable/${payableId}`, input);
                return data;
            },
            review: async (payableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/payable/${payableId}/review`, input);
                return data;
            },
            markReady: async (payableId) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payable/${payableId}/ready`);
                return data;
            },
            markNotReady: async (payableId) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payable/${payableId}/not-ready`);
                return data;
            },
        },
        payout: {
            list: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts`, {
                    params: query,
                });
                return data;
            },
            fetch: async (payoutId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/${payoutId}`);
                return data;
            },
            create: async (body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts`, body);
                return data;
            },
            addPayables: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/payables`, body);
                return data;
            },
            removePayable: async (payoutId, payableId) => {
                const { data } = await this.axiosInstance.mainInstance.delete(`/invoice/payouts/${payoutId}/payables/${payableId}`);
                return data;
            },
            submit: async (payoutId) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/submit`);
                return data;
            },
            approve: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/approve`, body ?? {});
                return data;
            },
            getTransferCapabilities: async (payoutId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/${payoutId}/transfer-capabilities`);
                return data;
            },
            getClearings: async (payoutId, query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/${payoutId}/clearings`, { params: query });
                return data;
            },
            applyClearing: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/apply-clearing`, body);
                return data;
            },
            applyClearingBatch: async (body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/apply-clearing-batch`, body);
                return data;
            },
            reject: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/reject`, body);
                return data;
            },
            retry: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/retry`, body ?? {});
                return data;
            },
            revertToPendingApproval: async (payoutId) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/revert-to-pending-approval`, {});
                return data;
            },
            resendRemittance: async (payoutId, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payouts/${payoutId}/resend-remittance`, body ?? {});
                return data;
            },
            downloadRemittance: async (payoutIds) => {
                const { data } = await this.axiosInstance.mainInstance.post('/invoice/payouts/download-remittance', { payoutIds }, { responseType: 'blob' });
                return data;
            },
            getCashFlow: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/cash-flow`, {
                    params: query,
                });
                return data;
            },
            getSummary: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/summary`, {
                    params: query,
                });
                return data;
            },
        },
        payment: {
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payment`, {
                    params: query,
                });
                return data;
            },
            fetch: async (paymentId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payment/${paymentId}`);
                return data;
            },
            /**
             * Query payments for a specific customer's receivables
             * @param customerID - The customer ID to filter payments for
             * @param query - Additional query parameters
             */
            queryByCustomer: async (customerID, query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/sourgum-internal/payment/receivables/${customerID}`, {
                    params: query,
                });
                return data;
            },
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             * @param input
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payment/${invoiceId}`, input);
                return data;
            },
        },
        paymentProcessing: {
            session: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/start-session', input);
                    return data;
                },
            },
            paymentMethodConfig: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/payment-method-config', input);
                    return data;
                },
            },
            payin: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/payins', input);
                    return data;
                },
                fetch: async (payinID) => {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payment-processing/payins/${payinID}`);
                    return data;
                },
            },
            creditCardRefundOrVoid: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/refunds', input);
                    return data;
                },
            },
            searchPayments: async (query) => {
                const { data } = await this.axiosInstance.appAdminInstance.get(`/invoice/admin/rainforest-payments`, { params: query });
                return data;
            },
        },
        refund: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             * @param input - The refund details to create
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/refund/${invoiceId}`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (invoiceId, consolidate) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/admin-portal/invoice/${invoiceId}`, {
                    params: {
                        consolidate: consolidate,
                    },
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        gmvSummary: async (query) => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/app-admin/gmv-summary`, {
                params: query,
            });
            return data;
        },
        coupon: {
            fetch: async (couponId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/sourgum-internal/coupon/${couponId}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/sourgum-internal/coupon`, {
                    params: query,
                });
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/sourgum-internal/coupon`, input);
                return data;
            },
            update: async (couponId, input) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/invoice/sourgum-internal/coupon/${couponId}`, input);
                return data;
            },
        },
        accountCredit: {
            fetch: async (accountCreditId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/account-credit/${accountCreditId}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/account-credit`, {
                    params: query,
                });
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/account-credit`, input);
                return data;
            },
        },
        billingPeriod: {
            /** Returns null when the billing period had nothing to bill (204). */
            generateInvoice: async (billingPeriodId) => {
                const response = await this.axiosInstance.mainInstance.post(`/invoice/v2/billing-period`, {
                    id: billingPeriodId,
                    suppressIssueInvoice: true,
                });
                return response.status === 204 ? null : response.data;
            },
        },
        autopay: {
            delete: async (autopayId) => {
                await this.axiosInstance.mainInstance.delete(`/invoice/autopay/${autopayId}`);
            },
        },
        payoutAttempt: {
            recordPayment: async (attemptID, body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payout-attempts/${attemptID}/record-payment`, body ?? {});
                return data;
            },
        },
        vendorOnboarding: {
            plaid: {
                createLinkToken: async (vendorID, redirectUri) => {
                    const payload = {};
                    if (vendorID)
                        payload.vendorID = vendorID;
                    if (redirectUri)
                        payload.redirectUri = redirectUri;
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/plaid/link-token', payload);
                    return data;
                },
                exchangeToken: async (vendorID, publicToken, institutionID) => {
                    const body = { publicToken };
                    if (vendorID)
                        body.vendorID = vendorID;
                    if (institutionID)
                        body.institutionID = institutionID;
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/plaid/exchange-token', body);
                    return data;
                },
            },
            addBankAccount: async (payload) => {
                const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/migrate-account', payload);
                return data;
            },
            getPaymentProfile: async (vendorID) => {
                const endpoint = vendorID
                    ? `/invoice/vendor-onboarding/payment-profile/${vendorID}`
                    : '/invoice/vendor-onboarding/payment-profile';
                const { data } = await this.axiosInstance.mainInstance.get(endpoint);
                return data;
            },
            updatePaymentProfile: async (vendorID, updates) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/invoice/vendor-onboarding/payment-profile/${vendorID}`, updates);
                return data;
            },
            vcc: {
                provision: async (vendorID) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/vcc/provision', vendorID ? { vendorID } : {});
                    return data;
                },
                cancel: async (vendorID) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/vcc/cancel', { vendorID });
                    return data;
                },
                getCardDetails: async (vendorID) => {
                    const { data } = await this.axiosInstance.mainInstance.get('/invoice/vendor-onboarding/vcc/card-details', { params: vendorID ? { vendorID } : {} });
                    return data;
                },
                getAuthorizations: async (vccID, vendorID) => {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/vendor-onboarding/vcc/${vccID}/authorizations`, { params: { vendorID } });
                    return data;
                },
                getToS: async (vendorID) => {
                    const { data } = await this.axiosInstance.mainInstance.get('/invoice/vendor-onboarding/vcc/tos', { params: vendorID ? { vendorID } : {} });
                    return data;
                },
                acceptToS: async (body) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/vendor-onboarding/vcc/tos-acceptance', body);
                    return data;
                },
            },
            getPayoutAccessLog: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get('/invoice/vendor-onboarding/payout-access-log', { params: query });
                return data;
            },
        },
        refSync: async (references) => {
            await this.axiosInstance.mainInstance.post(`/invoice/ref-sync`, references);
        },
    };
    wayste = {
        payout: {
            list: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts`, {
                    params: query,
                });
                return data;
            },
            fetch: async (payoutId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/${payoutId}`);
                return data;
            },
            getSummary: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payouts/summary`, {
                    params: query,
                });
                return data;
            },
            downloadRemittance: async (payoutIds) => {
                const { data } = await this.axiosInstance.mainInstance.post('/invoice/payouts/download-remittance', { payoutIds }, { responseType: 'blob' });
                return data;
            },
        },
        billingPeriod: {
            /** Returns null when the billing period had nothing to bill (204). */
            generateInvoice: async (billingPeriodId, options) => {
                const response = await this.axiosInstance.mainInstance.post(`/invoice/v2/billing-period`, {
                    id: billingPeriodId,
                    suppressIssueInvoice: options?.suppressIssueInvoice,
                    chargeNowPaymentMethodID: options?.chargeNowPaymentMethodID,
                    chargeNowPaymentProcessor: options?.chargeNowPaymentProcessor,
                });
                return response.status === 204 ? null : response.data;
            },
        },
        reports: {
            salesTaxLiability: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/reports/tax-liability`, input);
                return data;
            },
            payemntsBreakdown: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/reports/payments-breakdown`, input);
                return data;
            },
            getMetabaseUrl: async (dashboardId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/reports/metabase/url/${dashboardId}`);
                return data;
            },
            getMetabaseEmbedToken: async (dashboardId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/reports/metabase/embed-token/${dashboardId}`);
                return data;
            },
        },
        receivable: {
            fetch: async (receivableId) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable/${receivableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/receivable`, input);
                return data;
            },
            update: async (receivableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/wayste/receivable/${receivableId}`, input);
                return data;
            },
            charge: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/receivable-with-charge`, input);
                return data;
            },
            review: async (receivableID, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/wayste/receivable/${receivableID}/review`, input);
                return data;
            },
            combine: async (body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/combine-invoices`, body);
                return data;
            },
        },
        payment: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             * @param input
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/payment/${invoiceId}`, input);
                return data;
            },
        },
        paymentProcessing: {
            session: {
                create: this.adminPortal.paymentProcessing.session.create,
            },
            paymentMethodConfig: {
                create: this.adminPortal.paymentProcessing.paymentMethodConfig.create,
            },
            payin: {
                create: this.adminPortal.paymentProcessing.payin.create,
                fetch: this.adminPortal.paymentProcessing.payin.fetch,
            },
            creditCardRefundOrVoid: {
                create: this.adminPortal.paymentProcessing.creditCardRefundOrVoid.create,
            },
        },
        refund: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             * @param input - The refund details to create
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/refund/${invoiceId}`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (receivableID, params) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/${receivableID}`, {
                    responseType: 'blob',
                    params,
                });
                return res.data;
            },
            summary: {
                fetch: async (customerID, includeInvoices) => {
                    const res = await this.axiosInstance.mainInstance.post(`${this.axiosInstance.mainInstance.defaults.baseURL}/pdf/hauler/invoice/invoice-summary`, {
                        customerID,
                        includeInvoices,
                    }, { responseType: 'blob' });
                    return res.data;
                },
            },
            getBulkPDFs: async (receivableIDs) => {
                const res = await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/bulk-summary`, { receivableIDs }, { responseType: 'blob' });
                return res.data;
            },
        },
    };
    /**
     * Represents the customer portal functionality of the Invoice service.
     */
    customerPortal = {
        // Public routes for customer portal without authentication
        public: {
            paymentRequest: {
                create: async (token) => {
                    const res = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable/checkout/request/${token}`);
                    return res.data;
                },
            },
            invoicePayment: {
                create: async (accessLinkToken, invoicePayment) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/invoice/customer-portal/payment/via-token/${accessLinkToken}`, invoicePayment);
                    return data;
                },
            },
            pdf: {
                fetch: (token) => this.axiosInstance.mainInstance.get(`/pdf/customer-portal/invoice/token/${token}`, {
                    responseType: 'blob',
                }),
            },
        },
        invoicePayment: {
            create: async (invoicePayment) => {
                const { data } = await this.axiosInstance.mainInstance.post('/invoice/customer-portal/payment/process', invoicePayment);
                return data;
            },
        },
        paymentRequest: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/customer-portal/payment/request`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (receivableID) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/customer-portal/invoice/${receivableID}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        // Subroutes for receivables
        receivable: {
            /**
             * Fetches a receivable by its id
             * @param receivableId - The id of the receivable to fetch
             * @returns A promise that resolves to the requested receivable object
             */
            fetch: async (receivableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable/${receivableId}`);
                return data;
            },
            /**
             * Queries for receivables
             * @param query - The query to use for the search
             * @returns A promise that resolves to a paginated result of receivables
             */
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable`, {
                    params: query,
                });
                return data;
            },
        },
        summary: async () => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/summary`);
            return data;
        },
    };
    waysteDashboard = {
        customerSummary: async () => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/customer-summary`);
            return data;
        },
        pdf: {
            fetch: async (receivableID) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/wayste-dashboard/${receivableID}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        paymentRequest: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste-dashboard/payment/request`, input);
                return data;
            },
            process: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste-dashboard/payment/process`, input);
                return data;
            },
            processRainforest: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste-dashboard/payment/process-rainforest`, input);
                return data;
            },
        },
        // Rainforest session + payment-method-config endpoints for the dashboard.
        // Same underlying URLs as `adminPortal.paymentProcessing.*` — the `wayste-customer`
        // role was added to those routes' `requireAnyRole` lists so the dashboard can use
        // them. We expose the calls under `waysteDashboard.*` for semantic clarity: this
        // app is not admin-portal, and labeling them so makes that obvious to readers.
        paymentProcessing: {
            session: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/start-session', input);
                    return data;
                },
            },
            paymentMethodConfig: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/payment-processing/payment-method-config', input);
                    return data;
                },
            },
        },
    };
    /**
     * @deprecated use appropriate pathway for rest calls
     */
    pdf = {
        getPDF: async (receivableID) => {
            const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/${receivableID}`, {
                responseType: 'blob',
            });
            return res.data;
        },
        sendPDF: async (receivableID, sendPDFParams) => {
            return await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/${receivableID}/send`, {
                ...sendPDFParams,
            });
        },
    };
    /**
     * Unified billing (v2) receivables. Brand-agnostic — Sourgum is just another hauler, so there is
     * no per-app namespace here. Every endpoint is hauler-scoped server-side from the auth token,
     * so callers pass no haulerID.
     */
    v2 = {
        receivable: {
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/v2/receivable`, {
                    params: query,
                });
                return data;
            },
            fetch: async (receivableId) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/v2/receivable/${receivableId}`);
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/v2/receivable`, input);
                return data;
            },
            update: async (receivableId, input) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/v2/receivable/${receivableId}`, input);
                return data;
            },
            delete: async (receivableId) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const { data } = await this.axiosInstance.mainInstance.delete(`/invoice/v2/receivable/${receivableId}`);
                return data;
            },
            search: async (body) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/v2/receivable/search`, body);
                return data;
            },
        },
        lineItem: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/v2/line-item`, input);
                return data;
            },
            update: async (lineItems) => {
                if (lineItems.length === 0) {
                    throw new Error('lineItems is required');
                }
                const { data } = await this.axiosInstance.mainInstance.patch(`/invoice/v2/line-item`, {
                    lineItems,
                });
                return data;
            },
            delete: async (lineItemIds) => {
                if (lineItemIds.length === 0) {
                    throw new Error('lineItemIds is required');
                }
                const { data } = await this.axiosInstance.mainInstance.delete(`/invoice/v2/line-item`, {
                    data: { ids: lineItemIds },
                });
                return data;
            },
        },
        pdf: {
            fetch: async (receivableId) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/v2/${receivableId}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
            getBulkPDFs: async (receivableIDs) => {
                const res = await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/v2/bulk`, { receivableIDs }, { responseType: 'blob' });
                return res.data;
            },
            summary: async (customerID, includeInvoices, signal) => {
                const res = await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/v2/summary`, { customerID, includeInvoices }, { responseType: 'blob', signal });
                return res.data;
            },
        },
    };
    /**
     * Public Rainforest session and payment method config endpoints — no authentication required.
     * Use these for unauthenticated payment flows (e.g. public invoice payment links).
     * The underlying axios instance provides the correct base URL; no auth header is sent or required.
     */
    haulerPublic = {
        paymentProcessing: {
            session: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/hauler-public/payment-processing/start-session', input);
                    return data;
                },
            },
            paymentMethodConfig: {
                create: async (input) => {
                    const { data } = await this.axiosInstance.mainInstance.post('/invoice/hauler-public/payment-processing/payment-method-config', input);
                    return data;
                },
            },
        },
    };
}
export default InvoiceService;
//# sourceMappingURL=Invoice.service.js.map